<p-toast></p-toast>

<p-dialog
  [(visible)]="showAgentDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!submittingAgent"
  [blockScroll]="true"
  [appendTo]="'body'"
  [closeOnEscape]="!submittingAgent"
  styleClass="agent-form-dialog"
  [style]="{width: '760px', 'max-width': '95vw'}"
  [header]="agentDialogTitle"
  (onHide)="closeAgentDialog()">

  <div class="agent-form-panel">
    <div class="workspace-context" *ngIf="currentWorkspaceId">
      <i class="pi pi-briefcase"></i>
      <div>
        <strong>{{ currentWorkspaceName || ('supervisor.agents.dialog.currentWorkspace' | translate) }}</strong>
        <span>{{ currentWorkspaceId }}</span>
      </div>
    </div>

    <div class="workspace-context auto-fields-context">
      <i class="pi pi-cog"></i>
      <div>
        <strong>{{ 'supervisor.agents.dialog.autoFields.title' | translate }}</strong>
        <span>{{ 'supervisor.agents.dialog.autoFields.description' | translate }}</span>
      </div>
    </div>

    <form [formGroup]="agentForm" class="agent-form-grid" (ngSubmit)="onSubmitAgent()" novalidate>
      <div class="form-field" [class.invalid]="emailControl.invalid && emailControl.touched">
        <label for="agent-email">{{ 'supervisor.agents.form.email.label' | translate }}</label>
        <input
          id="agent-email"
          pInputText
          type="email"
          formControlName="email"
          [placeholder]="'supervisor.agents.form.email.placeholder' | translate" />
        <small class="field-error" *ngIf="emailControl.touched && emailControl.hasError('required')">
          {{ 'supervisor.agents.form.email.errorRequired' | translate }}
        </small>
        <small class="field-error" *ngIf="emailControl.touched && emailControl.hasError('email')">
          {{ 'supervisor.agents.form.email.errorInvalid' | translate }}
        </small>
        <small class="field-error" *ngIf="emailControl.touched && emailControl.hasError('backend')">
          {{ emailControl.getError('backend') }}
        </small>
      </div>

      <div class="form-field" [class.invalid]="firstNameControl.invalid && firstNameControl.touched">
        <label for="agent-first-name">{{ 'supervisor.agents.form.firstName.label' | translate }}</label>
        <input
          id="agent-first-name"
          pInputText
          type="text"
          formControlName="firstName"
          [placeholder]="'supervisor.agents.form.firstName.placeholder' | translate" />
        <small class="field-error" *ngIf="firstNameControl.touched && firstNameControl.hasError('required')">
          {{ 'supervisor.agents.form.firstName.errorRequired' | translate }}
        </small>
      </div>

      <div class="form-field" [class.invalid]="lastNameControl.invalid && lastNameControl.touched">
        <label for="agent-last-name">{{ 'supervisor.agents.form.lastName.label' | translate }}</label>
        <input
          id="agent-last-name"
          pInputText
          type="text"
          formControlName="lastName"
          [placeholder]="'supervisor.agents.form.lastName.placeholder' | translate" />
        <small class="field-error" *ngIf="lastNameControl.touched && lastNameControl.hasError('required')">
          {{ 'supervisor.agents.form.lastName.errorRequired' | translate }}
        </small>
      </div>

      <div class="form-field" [class.invalid]="documentControl.invalid && documentControl.touched">
        <label for="agent-document">{{ 'supervisor.agents.form.document.label' | translate }}</label>
        <input
          id="agent-document"
          pInputText
          type="text"
          formControlName="document"
          [placeholder]="'supervisor.agents.form.document.placeholder' | translate" />
        <small class="field-error" *ngIf="documentControl.touched && documentControl.hasError('required')">
          {{ 'supervisor.agents.form.document.errorRequired' | translate }}
        </small>
      </div>

      <div class="form-field form-field-full" [class.invalid]="passwordControl.invalid && passwordControl.touched" *ngIf="agentDialogMode === 'create'">
        <label for="agent-password">{{ 'supervisor.agents.form.password.label' | translate }}</label>
        <p-password
          inputId="agent-password"
          formControlName="password"
          [feedback]="true"
          [toggleMask]="true"
          [weakLabel]="'supervisor.agents.passwordStrength.weak' | translate"
          [mediumLabel]="'supervisor.agents.passwordStrength.medium' | translate"
          [strongLabel]="'supervisor.agents.passwordStrength.strong' | translate">
        </p-password>
        <small class="form-hint">{{ 'supervisor.agents.form.password.hint' | translate }}</small>
        <small class="field-error" *ngIf="passwordControl.touched && passwordControl.hasError('required')">
          {{ 'supervisor.agents.form.password.errorRequired' | translate }}
        </small>
        <small class="field-error" *ngIf="passwordControl.touched && passwordControl.hasError('minlength')">
          {{ 'supervisor.agents.form.password.errorMinLength' | translate }}
        </small>
        <small class="field-error" *ngIf="passwordControl.touched && passwordControl.hasError('noUppercase')">
          {{ 'supervisor.agents.form.password.errorNoUppercase' | translate }}
        </small>
        <small class="field-error" *ngIf="passwordControl.touched && passwordControl.hasError('noSpecialChar')">
          {{ 'supervisor.agents.form.password.errorNoSpecialChar' | translate }}
        </small>
      </div>

      <div class="form-field form-field-full otp-field">
        <label for="agent-enable-otp">{{ 'supervisor.agents.form.otp.label' | translate }}</label>
        <div class="otp-switch-row">
          <p-inputSwitch
            inputId="agent-enable-otp"
            formControlName="enableOTP">
          </p-inputSwitch>
          <span>{{ (enableOtpControl.value ? 'supervisor.agents.form.otp.enabled' : 'supervisor.agents.form.otp.disabled') | translate }}</span>
        </div>
        <small class="form-hint">{{ 'supervisor.agents.form.otp.hint' | translate }}</small>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        [label]="'supervisor.agents.common.cancel' | translate"
        icon="pi pi-times"
        styleClass="p-button-outlined"
        [disabled]="submittingAgent"
        (onClick)="closeAgentDialog()">
      </p-button>
      <p-button
        [label]="agentSubmitLabel"
        [icon]="agentDialogMode === 'create' ? 'pi pi-plus' : 'pi pi-save'"
        styleClass="p-button-success"
        [loading]="submittingAgent"
        [disabled]="submittingAgent"
        (onClick)="onSubmitAgent()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showConfigDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [blockScroll]="true"
  [appendTo]="'body'"
  [maximizable]="false"
  [closeOnEscape]="true"
  styleClass="agent-config-dialog"
  [style]="{width: '500px'}"
  [header]="selectedAgent ? (('supervisor.agents.config.headerPrefix' | translate) + selectedAgent.username) : ('supervisor.agents.config.header' | translate)"
  (onHide)="closeConfigDialog()">

  <div class="agent-config-panel" *ngIf="selectedAgent">
    <div class="agent-info">
      <div class="agent-avatar"
           [class.status-active]="!isLogoutDisabled(selectedAgent)"
           [class.status-disconnected]="isLogoutDisabled(selectedAgent)">
        <i [class]="getAgentIconClass(selectedAgent)"></i>
      </div>
      <div class="agent-details">
        <h4>{{selectedAgent.username}}</h4>
        <p class="agent-email">
          <i class="pi pi-envelope"></i>
          {{selectedAgent.email}}
        </p>
        <p class="agent-status">
          <i class="pi pi-circle-fill" [class.status-indicator-active]="!isLogoutDisabled(selectedAgent)"
             [class.status-indicator-disconnected]="isLogoutDisabled(selectedAgent)"></i>
          <strong>{{ 'supervisor.agents.config.statusLabel' | translate }}</strong> {{selectedAgent.status}}
        </p>
        <p class="agent-last-update">
          <i class="pi pi-clock"></i>
          <strong>{{ 'supervisor.agents.config.lastUpdateLabel' | translate }}</strong> {{selectedAgent.last_update | date:'dd/MM/yyyy HH:mm'}}
        </p>
      </div>
    </div>

    <div class="config-options">
      <ng-container *ngIf="isLogoutDisabled(selectedAgent); else logoutOptions">
        <div class="info-section">
          <div class="info-header">
            <i class="pi pi-info-circle"></i>
            <h5>{{ 'supervisor.agents.config.disconnected.title' | translate }}</h5>
          </div>
          <p class="info-text">{{ 'supervisor.agents.config.disconnected.text' | translate }}</p>
        </div>
      </ng-container>

      <ng-template #logoutOptions>
        <div class="warning-section">
          <div class="warning-header">
            <i class="pi pi-exclamation-triangle"></i>
            <h5>{{ 'supervisor.agents.config.confirmDisconnect.title' | translate }}</h5>
          </div>
          <p class="warning-text">{{ 'supervisor.agents.config.confirmDisconnect.questionBefore' | translate }}<strong>{{selectedAgent.username}}</strong>{{ 'supervisor.agents.config.confirmDisconnect.questionAfter' | translate }}</p>
          <p class="warning-description">{{ 'supervisor.agents.config.confirmDisconnect.description' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <ng-container *ngIf="selectedAgent && isLogoutDisabled(selectedAgent); else logoutButtons">
        <p-button
          [label]="'supervisor.agents.config.understood' | translate"
          icon="pi pi-check"
          styleClass="p-button-outlined"
          (onClick)="acknowledgeDisconnected()">
        </p-button>
      </ng-container>

      <ng-template #logoutButtons>
        <p-button
          [label]="'supervisor.agents.common.cancel' | translate"
          icon="pi pi-times"
          styleClass="p-button-outlined"
          (onClick)="cancelLogout()">
        </p-button>
        <p-button
          [label]="'supervisor.agents.config.disconnect' | translate"
          icon="pi pi-sign-out"
          styleClass="p-button-danger"
          (onClick)="confirmLogout()">
        </p-button>
      </ng-template>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showPasswordDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [blockScroll]="true"
  [appendTo]="'body'"
  [maximizable]="false"
  [closeOnEscape]="true"
  styleClass="password-change-dialog"
  [style]="{width: '600px', 'background-color': '#242424 !important'}"
  [header]="selectedAgent ? (('supervisor.agents.password.headerPrefix' | translate) + selectedAgent.username) : ('supervisor.agents.password.header' | translate)"
  (onHide)="closePasswordDialog()">

  <div class="password-change-panel" *ngIf="selectedAgent">
    <div class="agent-info">
      <div class="agent-avatar">
        <i class="pi pi-user"></i>
      </div>
      <div class="agent-details">
        <h4>{{selectedAgent.username}}</h4>
        <p>{{selectedAgent.email}}</p>
      </div>
    </div>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmitPassword()" novalidate class="password-form">
      <div class="form-group" [class.invalid]="newPassword.invalid && (newPassword.dirty || newPassword.touched)">
        <label for="new-password" id="new-password-label">{{ 'supervisor.agents.password.newLabel' | translate }}</label>
        <div class="p-inputgroup">
          <p-password
            id="new-password"
            formControlName="newPassword"
            [feedback]="true"
            [toggleMask]="true"
            [weakLabel]="'supervisor.agents.passwordStrength.weak' | translate"
            [mediumLabel]="'supervisor.agents.passwordStrength.medium' | translate"
            [strongLabel]="'supervisor.agents.passwordStrength.strong' | translate"
            aria-labelledby="new-password-label"
            aria-describedby="new-password-strength new-password-reqs"
            aria-required="true"
            [attr.aria-invalid]="newPassword.invalid && (newPassword.dirty || newPassword.touched)">
          </p-password>
        </div>

        <div *ngIf="newPassword.value" id="new-password-strength" aria-live="polite" class="password-strength-indicator">
          <span class="sr-only">{{ 'supervisor.agents.password.strengthSrLabel' | translate }}</span>
          <span [ngClass]="passwordStrengthClass">
            <i [class]="'pi ' + (passwordStrengthClass === 'strong' ? 'pi-shield' : passwordStrengthClass === 'medium' ? 'pi-check-circle' : 'pi-exclamation-circle')" aria-hidden="true"></i>
            {{ passwordStrengthText }}
          </span>
        </div>
      </div>

      <div class="form-group" [class.invalid]="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) || (showPasswordMismatch && (newPassword.dirty || confirmPassword.dirty))">
        <label for="confirm-password" id="confirm-password-label">{{ 'supervisor.agents.password.confirmLabel' | translate }}</label>
        <div class="p-inputgroup">
          <p-password
            id="confirm-password"
            formControlName="confirmPassword"
            [feedback]="false"
            [toggleMask]="true"
            aria-labelledby="confirm-password-label"
            aria-describedby="confirm-password-error"
            aria-required="true"
            [attr.aria-invalid]="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) || showPasswordMismatch">
          </p-password>
        </div>

        <div *ngIf="showPasswordMismatch && (newPassword.dirty || confirmPassword.dirty)"
             id="confirm-password-error"
             class="validation-error"
             aria-live="assertive">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          <span>{{ 'supervisor.agents.password.mismatch' | translate }}</span>
        </div>
        <div *ngIf="confirmPassword.errors?.['required'] && (confirmPassword.dirty || confirmPassword.touched)"
             class="validation-error"
             aria-live="assertive">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          <span>{{ 'supervisor.agents.password.requiredField' | translate }}</span>
        </div>
      </div>

      <div class="password-requirements" role="region" aria-labelledby="password-reqs-title" id="new-password-reqs">
        <h4 class="requirements-title" id="password-reqs-title">
          <i class="pi pi-shield" aria-hidden="true"></i>
          {{ 'supervisor.agents.password.requirements.title' | translate }}
        </h4>
        <ul class="requirements-list" aria-live="polite">
          <li [class.valid]="hasMinLength" [class.invalid]="showMinLengthError">
            <i class="pi" [ngClass]="hasMinLength ? 'pi-check-circle' : (showMinLengthError ? 'pi-times-circle' : 'pi-circle')" aria-hidden="true"></i>
            <span>{{ 'supervisor.agents.password.requirements.minLength' | translate }}</span>
          </li>
          <li [class.valid]="hasUpperCase" [class.invalid]="showUppercaseError">
            <i class="pi" [ngClass]="hasUpperCase ? 'pi-check-circle' : (showUppercaseError ? 'pi-times-circle' : 'pi-circle')" aria-hidden="true"></i>
            <span>{{ 'supervisor.agents.password.requirements.uppercase' | translate }}</span>
          </li>
          <li [class.valid]="hasSpecialChar" [class.invalid]="showSpecialCharError">
            <i class="pi" [ngClass]="hasSpecialChar ? 'pi-check-circle' : (showSpecialCharError ? 'pi-times-circle' : 'pi-circle')" aria-hidden="true"></i>
            <span>{{ 'supervisor.agents.password.requirements.specialChar' | translate }}</span>
          </li>
        </ul>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        [label]="'supervisor.agents.common.cancel' | translate"
        icon="pi pi-times"
        styleClass="p-button-outlined"
        (onClick)="closePasswordDialog()">
      </p-button>
      <p-button
        [label]="'supervisor.agents.password.submit' | translate"
        icon="pi pi-key"
        styleClass="p-button-success"
        [loading]="submittingPassword"
        loadingIcon="pi pi-spinner pi-spin"
        [disabled]="passwordForm.invalid || submittingPassword"
        (onClick)="onSubmitPassword()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<div class="dashboard-card-container">
  <div class="card"
       [class.loading-state]="loading"
       role="region"
       aria-labelledby="agents-header">

    <div *ngIf="loading"
         class="axede-loading-overlay axede-fade-in"
         role="status"
         aria-live="polite">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      <span class="sr-only">{{ 'supervisor.agents.loadingData' | translate }}</span>
    </div>

    <div class="card-header">
      <h3 id="agents-header" class="axede-fade-in">
        <i class="pi pi-users" aria-hidden="true"></i>
        <span>{{ 'supervisor.agents.title' | translate }}</span>
        <span class="agent-count">{{ 'supervisor.agents.countFound' | translate:{ count: totalRecords } }}</span>
      </h3>

      <p-toolbar class="agents-toolbar">
        <div class="p-toolbar-group-start">
          <div class="search-container">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange($event)"
                [placeholder]="'supervisor.agents.searchPlaceholder' | translate"
                class="search-input"
                [attr.aria-label]="'supervisor.agents.searchAriaLabel' | translate" />
            </span>
          </div>

          <div class="filter-container">
            <ng-container *ngIf="statusOptions$ | async as statusOptions; else loadingStatusOptions">
              <p-dropdown
                [options]="statusOptions"
                [(ngModel)]="selectedStatus"
                (onChange)="onStatusChange($event.value)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'supervisor.agents.filterByStatus' | translate"
                class="status-filter"
                [attr.aria-label]="'supervisor.agents.filterByStatus' | translate">

                <ng-template pTemplate="selectedItem">
                  <div class="status-option-selected" *ngIf="selectedStatus">
                    <span
                      class="status-circle"
                      [style.background-color]="getStatusColor(selectedStatus)">
                    </span>
                    <span>{{ selectedStatus || ('supervisor.agents.allStatuses' | translate) }}</span>
                  </div>
                  <span *ngIf="!selectedStatus">{{ 'supervisor.agents.allStatuses' | translate }}</span>
                </ng-template>

                <ng-template pTemplate="item" let-status>
                  <div class="status-option-item">
                    <span
                      class="status-circle"
                      [style.background-color]="status.color">
                    </span>
                    <span>{{ status.label }}</span>
                  </div>
                </ng-template>
              </p-dropdown>
            </ng-container>

            <ng-template #loadingStatusOptions>
              <i class="pi pi-spin pi-spinner" [attr.aria-label]="'supervisor.agents.loadingStatuses' | translate"></i>
            </ng-template>
          </div>
        </div>

        <div class="p-toolbar-group-end">
          <p-button
            *ngIf="searchTerm || selectedStatus"
            icon="pi pi-filter-slash"
            [label]="'supervisor.agents.clearFilters' | translate"
            styleClass="p-button-outlined p-button-sm"
            (onClick)="clearFilters()"
            [pTooltip]="'supervisor.agents.clearFiltersTooltip' | translate">
          </p-button>

          <p-button
            icon="pi pi-refresh"
            [label]="'supervisor.agents.refresh' | translate"
            styleClass="p-button-sm"
            (onClick)="refreshAgents()"
            [loading]="loading"
            [pTooltip]="'supervisor.agents.refreshTooltip' | translate">
          </p-button>
        </div>
      </p-toolbar>
    </div>

    <div class="table-container">
      <p-table
        #agentsTable
        id="agents-table"
        [value]="getDisplayedAgents()"
        styleClass="p-datatable-sm agents-table"
        [scrollable]="true"
        [tableStyle]="{'min-width': '60rem'}"
        [loading]="loading"
        [lazy]="false"
        responsiveLayout="scroll"
        [attr.aria-label]="'supervisor.agents.table.ariaLabel' | translate">

        <ng-template pTemplate="header">
          <tr>
            <th scope="col" pSortableColumn="username">
              {{ 'supervisor.agents.table.name' | translate }}
              <p-sortIcon field="username"></p-sortIcon>
            </th>
            <th scope="col" pSortableColumn="email">
              {{ 'supervisor.agents.table.email' | translate }}
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th scope="col" pSortableColumn="last_update">
              {{ 'supervisor.agents.table.lastUpdate' | translate }}
              <p-sortIcon field="last_update"></p-sortIcon>
            </th>
            <th scope="col" pSortableColumn="status">
              {{ 'supervisor.agents.table.status' | translate }}
              <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th scope="col">{{ 'supervisor.agents.table.actions' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-agent let-rowIndex="rowIndex">
          <tr [attr.aria-rowindex]="rowIndex + 1">
            <td>
              <div class="agent-info">
                <div class="agent-avatar">
                  <i class="pi pi-user"></i>
                </div>
                <div class="agent-details">
                  <span class="agent-name">{{agent.username}}</span>
                </div>
              </div>
            </td>

            <td>
              <span class="agent-email">{{agent.email}}</span>
            </td>

            <td>
              <span class="last-update">
                {{agent.last_update | date:'dd/MM/yyyy HH:mm'}}
              </span>
            </td>

            <td>
              <p-tag
                [value]="agent.status"
                [severity]="getStatusSeverity(agent.status)"
                class="status-tag">
              </p-tag>
            </td>

            <td>
              <div class="action-buttons">
                <p-button
                  icon="pi pi-pencil"
                  styleClass="p-button-sm p-button-text p-button-rounded"
                  [pTooltip]="'supervisor.agents.actions.editTooltip' | translate"
                  tooltipPosition="top"
                  [ariaLabel]="'supervisor.agents.actions.editAria' | translate:{ name: agent.username }"
                  (onClick)="showEditAgentDialog(agent)">
                </p-button>
                <p-button
                  icon="pi pi-key"
                  styleClass="p-button-sm p-button-text p-button-rounded p-button-secondary"
                  [pTooltip]="'supervisor.agents.actions.changePasswordTooltip' | translate"
                  tooltipPosition="top"
                  [ariaLabel]="'supervisor.agents.actions.changePasswordAria' | translate:{ name: agent.username }"
                  (onClick)="showChangePasswordDialog(agent)">
                </p-button>
                <p-button
                  icon="pi pi-cog"
                  [styleClass]="'p-button-sm p-button-text p-button-rounded' + (isLogoutDisabled(agent) ? ' disconnected-agent' : '')"
                  [pTooltip]="(isLogoutDisabled(agent) ? 'supervisor.agents.actions.viewInfoTooltip' : 'supervisor.agents.actions.configureTooltip') | translate"
                  tooltipPosition="top"
                  [ariaLabel]="'supervisor.agents.actions.configureAria' | translate:{ name: agent.username }"
                  (onClick)="showConfigurationPanel(agent)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr *ngFor="let item of [1,2,3,4,5]">
            <td><p-skeleton height="2rem"></p-skeleton></td>
            <td><p-skeleton height="2rem"></p-skeleton></td>
            <td><p-skeleton height="2rem"></p-skeleton></td>
            <td><p-skeleton height="2rem" width="5rem"></p-skeleton></td>
            <td><p-skeleton height="2rem" width="8rem"></p-skeleton></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="empty-state">
              <div class="empty-content">
                <i class="pi pi-users empty-icon" aria-hidden="true"></i>
                <h4>{{ 'supervisor.agents.empty.title' | translate }}</h4>
                <p *ngIf="searchTerm || selectedStatus; else noAgentsMessage">
                  {{ 'supervisor.agents.empty.filtered' | translate }}
                  <br>{{ 'supervisor.agents.empty.filteredHint' | translate }}
                </p>
                <ng-template #noAgentsMessage>
                  <p>{{ 'supervisor.agents.empty.none' | translate }}</p>
                </ng-template>
                <div class="empty-actions">
                  <p-button
                    *ngIf="searchTerm || selectedStatus"
                    [label]="'supervisor.agents.clearFilters' | translate"
                    icon="pi pi-filter-slash"
                    styleClass="p-button-outlined"
                    (onClick)="clearFilters()">
                  </p-button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="pagination-container" *ngIf="totalRecords > 0">
      <p-paginator
        [rows]="rows"
        [totalRecords]="totalRecords"
        [first]="first"
        [rowsPerPageOptions]="rowsPerPageOptions"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="false"
        [currentPageReportTemplate]="'supervisor.agents.paginator.report' | translate"
        [showJumpToPageDropdown]="false"
        [showPageLinks]="true"
        [attr.aria-label]="'supervisor.agents.paginator.ariaLabel' | translate">
      </p-paginator>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
